import { AddViewSupport48Container } from "../../../containers/SupportSystem/ViewReports/AddViewSupport48Container"
export function AddViewSupport48Page() {
    return (
        <AddViewSupport48Container />
    )
}